'use client';
import React, { Component } from 'react';
import './style.sass';

import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';

class Accelerator extends Component {
    render() {
        return (
            <ScrollAnimation className="accelerator">
                <div className="full-wrapper">
                    <CommonTitle>Акселератор</CommonTitle>
                    <div className="accelerator-bg">
                        <div className="accelerator-bg__title">О направлении:</div>
                        <div className="accelerator-bg__desc">
                            Основной задачей было получение заявок на прохождение акселератора по
                            минимальной цене. Первичные гипотезы были сделаны в пользу
                            таргетированной рекламы на Facebook, Instagram и ВК на аудиторию,
                            которая уже имеет опыт старта проектов или активно этим интересуется.
                            Это стало нашей ошибкой, по итогам первой итерации тестирований. Ниже
                            представлен наш путь, где где мы снизили стоимость лида в 5 раз!
                        </div>
                    </div>
                </div>

                <div className="starting">
                    <div className="full-wrapper">
                        <div className="starting__grid">
                            <div className="starting__number">1</div>
                            <ScrollAnimation
                                animateIn="fadeIn"
                                offset={50}
                                animateOnce={true}
                                duration={1}
                                className="starting__item starting__item--img"
                            >
                                <div className="starting__img">
                                    <img
                                        src="/images/pic/adventureLand/starting/1.png"
                                        alt="Пример баннера в ленте социальных сетей для целевой аудитории"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="starting__img-text">
                                    Пример баннера в ленте социальных сетей для целевой аудитории
                                </div>
                            </ScrollAnimation>
                            <ScrollAnimation
                                animateIn="fadeIn"
                                offset={50}
                                animateOnce={true}
                                duration={1}
                                className="starting__item starting__item--text"
                            >
                                <div className="starting__content">
                                    <div className="starting__title">Первый запуск</div>
                                    <div className="starting__subtitle">
                                        Таргетированная реклама
                                    </div>
                                    <div className="starting__desc">
                                        <ol>
                                            <li>
                                                Таргетирование на сервисы для стартаперов:
                                                Kickstarter, Сбор денег, Indiegogo, Краудфандинг,
                                                CrowdRise, GoFundMe, AngelList, Investing.com или
                                                Краудинвестинг
                                            </li>
                                            <li>
                                                Таргетирование на стартаперов: Инвестиционный фонд,
                                                Бизнес-акселератор, Startup Weekend, Венчурный
                                                капитал, Бизнес-ангел, Стартап, Инвестиционная
                                                стратегия, Инвестиции, Бизнес-инкубатор, ИнвестОР,
                                                Окупаемость инвестиций или Бережливый стартап
                                            </li>
                                            <li>По базе участников мероприятий Сколково</li>
                                        </ol>
                                    </div>
                                    <div className="starting__bot-text">
                                        Итоги первого шага — высокая стоимость лида, нестабильный
                                        приход заявок.
                                    </div>
                                </div>
                            </ScrollAnimation>
                        </div>
                    </div>
                </div>

                <div className="starting starting--converse">
                    <div className="full-wrapper">
                        <div className="starting__grid">
                            <div className="starting__number">2</div>
                            <ScrollAnimation
                                animateIn="fadeIn"
                                offset={50}
                                animateOnce={true}
                                duration={1}
                                className="starting__item starting__item--img"
                            >
                                <div className="starting__img">
                                    <img
                                        src="/images/pic/adventureLand/starting/2.png"
                                        alt="Пример объявлений в рекламной сети для целевой аудитории"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="starting__img-text">
                                    Пример объявлений в рекламной сети для целевой аудитории
                                </div>
                            </ScrollAnimation>
                            <ScrollAnimation
                                animateIn="fadeIn"
                                offset={50}
                                animateOnce={true}
                                duration={1}
                                className="starting__item starting__item--text"
                            >
                                <div className="starting__content">
                                    <div className="starting__title">Второй запуск</div>
                                    <div className="starting__subtitle">Контекстная реклама</div>
                                    <div className="starting__desc">
                                        <p>
                                            Реклама на Поиске и в РСЯ по узким ключевые фразам с
                                            операторами и кросс-минусовкой «площадки для стартапов»,
                                            «акселераторы стартапов», «поиск инвесторов», «поиск
                                            инвесторов для идеи». Посадочная:{' '}
                                            <a
                                                href="https://sk.ru/technopark/startup_accelerator/"
                                                target="_blank"
                                                rel="noopener noreferrer nofollow"
                                            >
                                                <b>https://sk.ru/technopark/startup_accelerator/</b>
                                            </a>
                                        </p>
                                    </div>
                                    <div className="starting__bot-text">
                                        Итоги второго запуска — стоимость лида ниже на 20%, но
                                        качество лидов неудовлетворительное.
                                    </div>
                                </div>
                            </ScrollAnimation>
                        </div>
                    </div>
                </div>

                <div className="starting">
                    <div className="full-wrapper">
                        <div className="starting__grid">
                            <div className="starting__number">3</div>
                            <div className="starting__end" />
                            <ScrollAnimation
                                animateIn="fadeIn"
                                offset={50}
                                animateOnce={true}
                                duration={1}
                                className="starting__item starting__item--img"
                            >
                                <div className="starting__img">
                                    <img
                                        src="/images/pic/adventureLand/starting/3.png"
                                        alt="Пример объявлений в поиске"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="starting__img-text">Пример объявлений в поиске</div>
                            </ScrollAnimation>
                            <ScrollAnimation
                                animateIn="fadeIn"
                                offset={50}
                                animateOnce={true}
                                duration={1}
                                className="starting__item starting__item--text"
                            >
                                <div className="starting__content">
                                    <div className="starting__title">Третий запуск</div>
                                    <div className="starting__subtitle">Контекстная реклама</div>
                                    <div className="starting__desc">
                                        <ol>
                                            <li>
                                                РСЯ, таргет: широкие ключевые фразы «стартап»,
                                                «бизнес идея» и т.п.
                                            </li>
                                            <li>Ретаргетинг на посетителей сайтов</li>
                                            <li>Ретаргетинг на посетителей сервисов sk.ru</li>
                                        </ol>
                                    </div>
                                    <div className="starting__bot-text">
                                        Итоги третьего запуска — стоимость лида ниже первоначальной
                                        в 5 раз.
                                    </div>
                                </div>
                            </ScrollAnimation>
                        </div>
                    </div>
                </div>

                <div className="results-bg">
                    <div className="full-wrapper">
                        <ScrollAnimation
                            animateIn="fadeIn"
                            offset={50}
                            animateOnce={true}
                            duration={1}
                            className="results-bg__top"
                        >
                            <div className="results-bg__title">Самая рабочая гипотеза:</div>
                            <div className="results-bg__text">
                                смещение акцента в рекламе на бесплатность, наставничество, онлайн,
                                DemoDay.
                            </div>
                        </ScrollAnimation>

                        <ScrollAnimation
                            animateIn="fadeIn"
                            offset={50}
                            animateOnce={true}
                            duration={1}
                            className="results-bg__bot"
                        >
                            <div className="results-bg__bot-title">Результаты:</div>
                            <div className="results-bg__bot-grid">
                                <div className="results-bg__bot-item">
                                    <div className="results-bg__bot-big">513</div>
                                    <div className="results-bg__bot-text">
                                        регистраций
                                        <br />в акселератор
                                    </div>
                                </div>
                                <div className="results-bg__bot-item">
                                    <div className="results-bg__bot-big">108</div>
                                    <div className="results-bg__bot-text">
                                        рублей — минимальная
                                        <br />
                                        стоимость лида
                                    </div>
                                </div>
                                <div className="results-bg__bot-item">
                                    <div className="results-bg__bot-big">канал</div>
                                    <div className="results-bg__bot-text">
                                        контекстная реклама
                                        <br />в сетях
                                    </div>
                                </div>
                            </div>
                        </ScrollAnimation>
                    </div>
                </div>
            </ScrollAnimation>
        );
    }
}

export default Accelerator;
